import { render, staticRenderFns } from "./AnnouncementContent.vue?vue&type=template&id=764cec01&scoped=true&"
import script from "./AnnouncementContent.vue?vue&type=script&lang=js&"
export * from "./AnnouncementContent.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementContent.vue?vue&type=style&index=0&id=764cec01&prod&lang=scss&scoped=true&"
import style1 from "./AnnouncementContent.vue?vue&type=style&index=1&id=764cec01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764cec01",
  null
  
)

export default component.exports